import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'

import NavbarComponent from '@/components/Home/Navbar'

@inject('store')
@observer
export default class NavbarContainer extends Component {
  render() {
    return <NavbarComponent />
  }
}


// WEBPACK FOOTER //
// ./src/containers/Home/Navbar/index.js